export default __webpack_public_path__ + "static/media/currency_rupee2.fdae15b7.svg";